import { AppVersionConstants } from '../constants';
import { AppVersionService } from '../../services/';


export const AppVersionActions = {
	fetchAppVersion,
		
};

function fetchAppVersion() {
	return (dispatch) => {
		dispatch(request());

		AppVersionService.fetchAppVersion().then(
			(version) => {
				dispatch(success(version));
			},
			(error) => dispatch(failure(error.toString()))
		);
	};
}

function request() {
	return { type: AppVersionConstants.GETAPPVERSION_REQUEST };
}

function success(objVersion) {
	if (objVersion) {
		const api_app_version = objVersion.app_version;
		const storage_app_version = localStorage.getItem('app_version');

		if (storage_app_version !== null) {
			if (api_app_version > storage_app_version) {
				if (window.localStorage) {
					if (!localStorage.getItem('firstLoad')) {
						localStorage['firstLoad'] = true;
						window.location.reload(true);
					} else localStorage.removeItem('firstLoad');
				}
				localStorage.setItem('app_version', api_app_version);
			}
		} else {
			localStorage.setItem('app_version', api_app_version);
		}
		return { type: AppVersionConstants.GETAPPVERSION_SUCCESS, objVersion };
    }
}

function failure(error) {
	return { type: AppVersionConstants.GETAPPVERSION_FAILURE, error };
}



// WEBPACK FOOTER //
// ./src/store/actions/appVersion.actions.js